import type { ZoneConnectionType } from "@/types"
import { ColumnDef } from "@tanstack/react-table"

import { DataTableColumnHeader } from "../../data-table"
import { ZoneConnectionRatesPage } from "../operations/zone-connection-rates-operations"

export const connectionRates: ColumnDef<ZoneConnectionType>[] = [
  {
    accessorKey: "zone",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Zone" />
    ),
    cell: ({ row }) => {
      const value = row.original.zone
      return <div className="text-right md:py-0 md:text-left">{value}</div>
    },
  },
  {
    accessorKey: "connection_type",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-end"
        column={column}
        title="Connection type"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.connection_type
      return <div className="text-right md:py-0 md:text-center">{value}</div>
    },
  },
  {
    accessorKey: "price_per_cubic",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-end"
        column={column}
        title="Price Per Cubic"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.price_per_cubic
      return (
        <div className="text-right md:py-0 md:text-center">
          {value.toFixed(1)}
        </div>
      )
    },
  },
  {
    accessorKey: "environmental_charges_perecentage",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-end"
        column={column}
        title="Environmental Charges Percentage"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.environmental_charges_percentage
      return <div className="text-right md:py-0 md:text-center">{value}</div>
    },
  },
  {
    accessorKey: "maintenance_service_charge",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-end"
        column={column}
        title="Maintenance Service Charge"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.maintenance_service_charge
      return (
        <div className="text-right md:py-0 md:text-center">
          {value.toFixed(1)}
        </div>
      )
    },
  },
  {
    accessorKey: "government_charge_percentage",
    header: ({ column }) => (
      <DataTableColumnHeader
        className="flex justify-end"
        column={column}
        title="Government Charge Percentage"
      />
    ),
    cell: ({ row }) => {
      const value = row.original.government_charges_percentage
      return <div className="text-right md:py-0 md:text-center">{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <ZoneConnectionRatesPage data={row.original} />
        </div>
      )
    },
  },
]
